import { ChevronRight, Home } from "lucide-react";
import { Link } from "react-router-dom";

interface PreviewBreadcrumbProps {
  provider: {
    id: number;
    name: string;
  };
  version: {
    id: number;
    version_number: string;
  };
}

export function PreviewBreadcrumb({ provider, version }: PreviewBreadcrumbProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Link to="/providers" className="hover:text-foreground">
        <Home className="h-4 w-4" />
      </Link>
      <ChevronRight className="h-4 w-4" />
      <Link 
        to={`/providers/${provider.id}/versions`}
        className="hover:text-foreground"
      >
        {provider.name}
      </Link>
      <ChevronRight className="h-4 w-4" />
      <Link 
        to={`/providers/${provider.id}/versions/${version.id}`}
        className="hover:text-foreground"
      >
        Version {version.version_number}
      </Link>
      <ChevronRight className="h-4 w-4" />
      <span>Preview</span>
    </div>
  );
} 